import { isString } from '@grandvisionhq/utils';
import { getProductImageUrl } from '../utils/get-product-image-url.js';
import { convertCentToDecimal } from '../utils/convert-cent-to-decimal.js';
import { getIsAvailableForSubscription } from '../utils/get-is-available-for-subscription.js';
import { getIsAvailableForInstoreSubscription } from '../utils/get-is-available-for-instore-subscription.js';
import { getMetaTitle, getMetaDescription } from '../utils/get-product-seo-info.js';
import { getProductMedia } from '../utils/get-product-media.js';
import { getProductTag } from '../utils/get-product-tag.js';
import { getPurchaseTypePrices } from '../utils/get-purchase-type-prices.js';
import '@swc/helpers';
import { getProductInventoryChannels } from '../utils/get-product-inventory-channels.js';

const mapServerToVariantBase = (serverVariant, serverProduct, slug, locale, priceSegmentChannelKey)=>{
    var ref;
    const { variantTypeDetails , description: variantDescription , displayName , sku  } = serverVariant;
    const purchaseTypePrices = getPurchaseTypePrices(serverVariant.priceList, locale, priceSegmentChannelKey);
    if (!purchaseTypePrices) {
        console.error(`Cannot render variant with sku "${sku}" because it does not have a price for single-purchase`);
        return;
    }
    const { description: productDescription  } = serverProduct;
    const bestPrice = convertCentToDecimal(serverVariant.bestPrice);
    const description = [
        variantDescription,
        productDescription
    ].find(isString);
    const media = getProductMedia(serverVariant.media);
    const metaTitle = getMetaTitle(serverVariant, serverProduct);
    const metaDescription = getMetaDescription(serverVariant, serverProduct);
    const ogImageUrl = getProductImageUrl(serverVariant.media);
    const inventoryChannels = getProductInventoryChannels(serverVariant.inventory);
    const productTag = getProductTag(serverVariant.tags);
    const channelAvailability = variantTypeDetails.channelAvailability;
    const isAvailableForInStoreSubscription = getIsAvailableForInstoreSubscription(serverVariant, purchaseTypePrices);
    const isAvailableForSubscription = getIsAvailableForSubscription(serverVariant, purchaseTypePrices);
    // recommendedCategoryKey has not yet been implemented on the BE for Frames,
    // but the FE should treat it as possible for any product type
    let recommendedCategoryKey;
    if ('recommendedCategoryKey' in variantTypeDetails) {
        var _recommendedCategoryKey;
        recommendedCategoryKey = (_recommendedCategoryKey = variantTypeDetails.recommendedCategoryKey) !== null && _recommendedCategoryKey !== void 0 ? _recommendedCategoryKey : undefined;
    }
    var _header, _promotionIdentifier, ref1;
    return {
        bestPrice,
        channelAvailability,
        displayName,
        description,
        shortDescription: (_header = serverVariant.header) !== null && _header !== void 0 ? _header : undefined,
        sku,
        slug,
        variantUsps: serverVariant.usps,
        productTag,
        isExcludedFromCheckout: !!serverVariant.isExcludedFromCheckout,
        isAvailableForInStoreSubscription,
        isAvailableForSubscription,
        media,
        purchaseTypePrices,
        promotionIdentifier: (_promotionIdentifier = serverVariant.promotionIdentifier) !== null && _promotionIdentifier !== void 0 ? _promotionIdentifier : undefined,
        recommendedCategoryKey,
        seoConfig: {
            metaTitle,
            metaDescription,
            ogImageUrl
        },
        isPublished: serverVariant.isPublished,
        stock: {
            enableStockIndicator: !serverVariant.isExcludedFromCheckout,
            isAllowBackOrder: !!serverVariant.isAllowBackOrder,
            stockCount: (ref1 = (ref = serverVariant.inventory) === null || ref === void 0 ? void 0 : ref.totalQuantity) !== null && ref1 !== void 0 ? ref1 : 0
        },
        inventoryChannels
    };
};

export { mapServerToVariantBase };
//# sourceMappingURL=map-server-to-variant-base.js.map
